import React, { useState } from 'react';
// import './BottomNavig.css';

import {  Link } from 'react-router';
import { styled } from '@mui/material/styles';

import BottomNavigation from '@mui/material/BottomNavigation';
import BottomNavigationAction from '@mui/material/BottomNavigationAction';
import HomeOutlinedIcon from '@mui/icons-material/HomeOutlined';
import FavoriteIcon from '@mui/icons-material/Favorite';
import AddIcon from '@mui/icons-material/Add';

import useScrollTrigger from '@mui/material/useScrollTrigger';
import Slide from '@mui/material/Slide';
import IconButton from '@mui/material/IconButton';
import Badge, { badgeClasses } from '@mui/material/Badge';

// context
import { useFavorites } from "../../../Context/FavoritesContext";

// Theme
import { useTheme } from '@mui/material/styles';

// icons:
import TuneOutlinedIcon from '@mui/icons-material/TuneOutlined';
import { GrUserSettings } from "react-icons/gr";
import { FaRegUser } from "react-icons/fa";
import { FaSearch } from "react-icons/fa"

// translation:
// import { useTranslation } from 'react-i18next';
// import zIndex from '@mui/material/system/zIndex';

// import Services from '../../routes/Services/Services';

const CartBadge = styled(Badge)`
  & .${badgeClasses.badge} {
    top: -16px;
    right: -3px;
  }
`;

function HideOnScroll(props) {
    const trigger           = useScrollTrigger();

    return (
        <Slide appear={false} direction="up" in={!trigger}>
        {props.children}
        </Slide>
    );
}


function BottomNav({onFilterClick}) {

    const [bottomTab, setBottomTab] = useState('recents'),
          favoritesList = useFavorites();





    const handleChange = ( oEvent,  newValue ) => {
        setBottomTab(newValue);
        // navigate(newValue);
    };

    // const onCreate = (oEvent) => {
    //     alert('hi')
    // }

    return(
        <HideOnScroll>
        <BottomNavigation
            sx={{ display: 'flex', 
                  width: '100vw',
                  position: 'fixed',
                  top: 'auto',
                  bottom: '0',
                  zIndex: '2',
                  "@media (min-width:1024px) and (max-width:1280px)" : {
                    width: 1024,
                    maxWidth: 1024,
                    mx: 'auto',
                    display:'none'
                },
                "@media screen and (min-width:1280px)" : {
                    width: 1024,
                    maxWidth: 1024,
                    mx: 'auto',
                    display:'none'
                }   
                }} 
            value={bottomTab}
            onChange={handleChange}>

            <BottomNavigationAction
                sx={{ '&:hover': { color: '#008CBA' }, '&:active': { color: '#008CBA' }   }} 
                component={Link}
                to="/"
                label="Home"
                value="home"
                icon={<HomeOutlinedIcon />}
            />

            <BottomNavigationAction
                component={Link}
                onClick={ (oEvent) => onFilterClick('fltr',oEvent) } 
                label="filter"
                icon={<FaSearch/>}>
                {/* TuneOutlinedIcon */}
            </BottomNavigationAction>


            {/* <BottomNavigationAction
                sx={{ '&:hover': { color: '#008CBA' }, '&:active': { color: '#008CBA' }   }} 
                // onClick={onCreate}
                component={Link}
                label="new"
                to="/newItem"
                value="New"
                icon={<AddIcon />}
            /> */}

            <BottomNavigationAction
                sx={{ '&:hover': { color: '#008CBA' }, '&:active': { color: '#008CBA' }   }} 
                component={Link}
                to="/favorites"
                label="Favorites"
                value="favorites"
                icon={<IconButton>
                    <FavoriteIcon/> 
                    {/* FavoriteIcon */}
                    {/* badgeContent={favoriteCount} */}
                    <CartBadge invisible={favoritesList.length > 0 ? false : true } badgeContent={favoritesList.length}  color="error" overlap="circular" />
                </IconButton>}
            />

            {/* <BottomNavigationAction
                sx={{ '&:hover': { color: '#008CBA' }, '&:active': { color: '#008CBA' }   }} 
                // label="more"
                value="contact" 
                icon={<PermPhoneMsgOutlinedIcon/>} 
                /> */}

            {/* <BottomNavigationAction
               sx={{ '&:hover': { color: '#008CBA' }, '&:active': { color: '#008CBA' }   }} 
                component={Link}
                to="/services"
                label="Services"
                value="services"
                icon={<VolunteerActivismOutlinedIcon />}
            /> */}

            {/* <BottomNavigationAction
                sx={{ '&:hover': { color: '#008CBA' }, '&:active': { color: '#008CBA' }   }} 
                component={Link}
                to="/favorites"
                label="Favorites"
                value="favorites"
                icon={<FavoriteIcon />}
            /> */}
            <BottomNavigationAction
                component={Link}
                sx={{ '&:hover': { color: '#008CBA' }, '&:active': { color: '#008CBA' }   }} 
                label="more"
                value="more" 
                icon={<FaRegUser/>} 
                />
        </BottomNavigation>

    </HideOnScroll>

        
    )
}
export default BottomNav;